import 'rxjs/add/operator/debounceTime';
import {Component} from '@angular/core';
import {AlertController, NavController, NavParams, ViewController} from 'ionic-angular';

import {CONFIG} from '../../../app/config';
import {
    TAction,
    TFiscalRegime,
    TReceitaFlag,
} from "../../../app/enum";
import {TFieldType, TGoogleAnalytic, TStatusBar, Util} from "../../../app/util";

import {LogadoService} from '../../../providers/logado-service';
import {ProfileService} from "../../../providers/profile-service";
import {ProfileRepository} from "../../../repositories/profile-repository";
import {NetworkInterface} from "@ionic-native/network-interface";
import {MessageService} from "../../../providers/message-service";
import {WebstorService} from "../../../providers/webstor-service";
import {ModalFieldPage} from '../modal-field/modal-field';

@Component({
    selector: 'page-emissor-menu',
    templateUrl: 'emissor-menu.html',
    providers: [WebstorService, ProfileService, ProfileRepository]
})
export class EmissorMenuPage {

    TReceitaFlag: any = TReceitaFlag;
    TFiscalRegime: any = TFiscalRegime;

    config: any;
    logado: any;
    rootile: any;
    copyile: any;

    etapa: number;

    emissorStep: number;

    constructor(public viewCtrl: ViewController, public navCtrl: NavController, public navParams: NavParams,
                public messageService: MessageService, public networkInterface: NetworkInterface,
                public util: Util, public webstorService: WebstorService,
                public logadoService: LogadoService, public profileService: ProfileService, public profileRepository: ProfileRepository,
                public alertCtrl: AlertController) {

        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();
        this.rootile = this.navParams.get('rootile');
        this.copyile = this.util.deepCopy(this.rootile);

        this.etapa = this.navParams.get('etapa');

        this.emissorStep = 0;


        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Profile Menu', '/profile-menu');

    }

    ionViewDidEnter() {

        this.util.statusBarColor(TStatusBar.sbStyleLightContent);

    }

    getTitle() {

        return (this.copyile ? this.copyile.Profile.ProfileShow : '... Carregando ...');

    }

    receitaOpen() {

        let profileCnpj = this.copyile.Profile.ProfileCnpj;
        if (profileCnpj)  this.profileRepository.emissorSite(this.copyile.Addresss, 'PJ-FIND');
        if (!profileCnpj) this.profileRepository.emissorSite(this.copyile.Addresss, 'PF-FIND');

    }

    emissorMask() {

        if (this.copyile.Addresss[0].Zipcity.ZipcityZone == 'SP') return 'AAAAAAAA-AAAA-AAAA-AAAA-AAAAAAAAAAAAAAA';
        if (this.copyile.Addresss[0].Zipcity.ZipcityZone == 'RJ') return 'AAAAAAAA-AAAA-AAAA-AAAA-AAAAAAAAAAAAAAA';
        if (this.copyile.Addresss[0].Zipcity.ZipcityZone == 'SC') return 'AAAAAAAA-AAAA-AAAA-AAAA-AAAAAAAAAAAAAAA';
        if (this.copyile.Addresss[0].Zipcity.ZipcityZone == 'RR') return 'AAAAAAAA-AAAA-AAAA-AAAA-AAAAAAAAAAAAAAA';
        if (this.copyile.Addresss[0].Zipcity.ZipcityZone == 'BA') return 'AAAAAAAA-AAAA-AAAA-AAAA-AAAAAAAAAAAAAAA';
        if (this.copyile.Addresss[0].Zipcity.ZipcityZone == 'SE') return 'AAAAAAAA-AAAA-AAAA-AAAA-AAAAAAAAAAAAAAA';
        if (this.copyile.Addresss[0].Zipcity.ZipcityZone == 'PI') return '000000000000000000000000000000000000000';
        return 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA';

    }

    emissorAnex() {

        let onSave = (anex) => {
            this.copyile.Profile.EmissorAnex = anex;
            this.emissorSave();
        };

        /** OPEN **/
        let buttons: Array<any> = [];
        buttons.push({text: 'Anexo I - Comercio',   handler: () => onSave(1)});
        buttons.push({text: 'Anexo II - Industria', handler: () => onSave(2)});
        buttons.push({text: 'Anexo III - Serviço',  handler: () => onSave(3)});
        buttons.push({text: 'Anexo IV - Serviço',   handler: () => onSave(4)});
        buttons.push({text: 'Anexo V - Serviço',    handler: () => onSave(5)});
        this.util.sheetOpen(buttons, 'ANEXO TABELA');

    }

    emissorToid(toid) {

        this.copyile.Profile.EmissorToid = toid;

    }

    emissorSlot(slot, auto: boolean = true) {

        if (auto && slot == 2) {
            /** OPEN **/
            let buttons: Array<any> = [];
            buttons.push({text: 'Série 2', handler: () => this.emissorSlot(2, false)});
            buttons.push({text: 'Série 3', handler: () => this.emissorSlot(3, false)});
            buttons.push({text: 'Série 4', handler: () => this.emissorSlot(4, false)});
            buttons.push({text: 'Série 5', handler: () => this.emissorSlot(5, false)});
            this.util.sheetOpen(buttons, 'SÉRIE');
            return;
        }

        this.copyile.Profile.EmissorSlot = slot;

    }

    emissorIcms() {

        let onSave = (value, extra) => {
            this.copyile.Profile.EmissorIcms = value;
            this.emissorSave();
        };

        this.util.pickerCash(0, 30, 1, this.copyile.Profile.EmissorIcms, onSave, null, true);

    }

    emissorIcmr() {

        let onSave = (value, extra) => {
            this.copyile.Profile.EmissorIcmr = value;
            this.emissorSave();
        };

        this.util.pickerCash(0, 90, 1, this.copyile.Profile.EmissorIcmr, onSave, null, true);

    }

    emissorText() {

        let json = this.copyile.Profile.EmissorText;
        let nome = (json ? json.Nome : '');
        let info = (json ? json.Info : '');
        let text = (json ? json.Text : '');

        let onOkiy = (that, okiy, index, isLast) => {

            if (this.util.slideNext(that, (index < okiy.length -1))) return;

            nome = okiy[0].groups[0].fields[0].value;
            info = okiy[1].groups[0].fields[0].value;
            text = okiy[2].groups[0].fields[0].value;

            this.copyile.Profile.EmissorText = {Nome: nome, Info: info, Text: text};
            this.emissorSave(null, that);

        };


        let fieldNome = this.config.modalField(TFieldType.ftLine, 'Nome', 'Não colcar ENTER', null, nome, null, null);
        let groupNome = this.config.modalGroup(null, [fieldNome]);

        let fieldInfo = this.config.modalField(TFieldType.ftText, 'Info', 'Não colcar ENTER', null, info, null, null);
        let groupInfo = this.config.modalGroup(null, [fieldInfo]);

        let fieldText = this.config.modalField(TFieldType.ftText, 'Text', 'Não colcar ENTER', null, text, null, null);
        let groupText = this.config.modalGroup(null, [fieldText]);

        /** SLIDE SET **/
        let slides = [];
        slides.push(this.config.modalSlide('Regime Especial', null, null, null, 'CorRoxa', [groupNome]));
        slides.push(this.config.modalSlide('Regime Especial', null, null, null, 'CorRoxa', [groupInfo]));
        slides.push(this.config.modalSlide('Regime Especial', null, null, null, 'CorRoxa', [groupText]));

        this.util.modalopen(ModalFieldPage, 'alto', false, {slides: slides, onOkiy: onOkiy}).subscribe();

    }

    emissorInfo(line) {
        
        let site = (this.copyile.Addresss && this.copyile.Addresss[0] ? this.copyile.Addresss[0].Zipcity.ZipcityZone : 'XX') + '-NFC';

        if (site == 'PR-NFC') {
            let result = '';
            if (line == 1) result = '<b>CNPJ :</b> UPD » Autoriza » Cadastro';
            if (line == 2) result = '• ==========================';
            if (line == 3) result = '<b>OLHAL</b> UPD » Sistema » Reconhe';
            if (line == 4) result = '• ==========================';
            if (line == 5) result = '<b>CNPJ :</b> Homolog depois Prod:';
            if (line == 6) result = 'DF-e » NFC-e » CSC » Controle';
            
            for (let i = 1; i <=10; i++) result.replace(' » ', ' <b>»</b> ');
            return result;
        }

        if (site == 'SC-NFC') {

            if (line == 1) return '• <b>Buscar por</b>: "Manutenção de"';                                    //'• Informar para Contador:';
            if (line == 2) return '• Autorização de Uso PAF-NFC';                                            //'• Software Lorean';
            if (line == 3) return '• <b>Click botão: </b>Incluir PAF';                                       //'• Versão 5';
            if (line == 4) return '• -------------------------------------';                                 //'• TTD 707';
            if (line == 5) return '• CNPJ - <a href="https://www.sef.sc.gov.br/nfce" target=”_blank”>Link para gerar o CSC</a>';     //'• CNPJ'
            if (line == 6) return '• Cliente: <a href="https://sat.sef.sc.gov.br/tax.NET/Sat.Dfe.NFCe.Web/GestaoDeCscs.aspx" target=”_blank”>Gerar o CSC</a>';

        }

        return '';
        
    }

    emissorDone(save) {

        if ( save) this.emissorSave();
        if (!save) {
            this.util.populateObj(this.copyile, this.rootile);
            this.dismiss();
        }

    }

    emissorFile() {

        let filebyte = (20 * 1024);
        let acceptis = 'application/x-pkcs12,.pfx';
        let options = {acceptTypes: acceptis, sizebyte: filebyte, selectLimit: 0, minmax: 'FIX', width: 0, height: 0, quality: 100};
        this.util.fileSelect(options).subscribe(
            base => {

                let onDone = (data) => {
                    if (data == null) return;
                    this.copyile.Profile.EmissorPswd = data.Password;
                    this.copyile.Profile.EmissorCert64 = base[0].base64.split(',')[1];
                };

                // ***** KEYLOCK YES ***** //
                let buttons: Array<any> = [];
                buttons.push({text: 'Cancelar', hole: 'cancel'});
                buttons.push({text: 'Pronto', hole: null, handler: (data) => onDone(data)});
                let inputs = [{type: 'text', name: 'Password', placeholder: 'Senha do certificado'}];
                this.alertCtrl.create({title: 'Certificado Senha', inputs: inputs, buttons: buttons}).present();

            },

            erro => this.util.alertResult(erro)
        );

    }

    emissorSave(profile: any = null, that: any = null) {

        let onDone = () => {
            this.util.populateObj(this.rootile, this.copyile);

            if (that) that.dismiss();
            this.dismiss(profile);
        };

        let onBack = () => {
            this.util.populateObj(this.copyile, this.rootile);
            this.rootile.Profile.EmissorCert64 = '';
            this.copyile.Profile.EmissorCert64 = '';
        }

        //ProfileSave
        let loading = this.util.loadingDots();
        loading.present();

        this.profileService.emissor(TAction.acSave, this.copyile.Profile.ProfileID, this.copyile.Profile)
            .finally(() => loading.dismiss())
            .subscribe(
                data => onDone(),
                erro => this.util.alertResult(erro, () => onBack())
            );

    }



    dismiss(data?) {

        if (this.copyile) {
            this.copyile.Profile.ProfileFace64 = '';
            this.copyile.Profile.ProfileBody64 = '';
        }

        this.util.statusBarColor(TStatusBar.sbStyleLightContent);

        if (this.viewCtrl.isOverlay) {
            this.viewCtrl.dismiss(data);
            return;
        }

        this.navCtrl.pop();

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/emissor-menu/emissor-menu.ts